/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VendorTokenRouteImport } from './routes/vendor/$token'
import { Route as CustomerTokenRouteImport } from './routes/customer/$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorTokenRoute = VendorTokenRouteImport.update({
  id: '/vendor/$token',
  path: '/vendor/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerTokenRoute = CustomerTokenRouteImport.update({
  id: '/customer/$token',
  path: '/customer/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/customer/$token': typeof CustomerTokenRoute
  '/vendor/$token': typeof VendorTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/customer/$token': typeof CustomerTokenRoute
  '/vendor/$token': typeof VendorTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/customer/$token': typeof CustomerTokenRoute
  '/vendor/$token': typeof VendorTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/customer/$token' | '/vendor/$token'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/customer/$token' | '/vendor/$token'
  id: '__root__' | '/' | '/customer/$token' | '/vendor/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CustomerTokenRoute: typeof CustomerTokenRoute
  VendorTokenRoute: typeof VendorTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendor/$token': {
      id: '/vendor/$token'
      path: '/vendor/$token'
      fullPath: '/vendor/$token'
      preLoaderRoute: typeof VendorTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/$token': {
      id: '/customer/$token'
      path: '/customer/$token'
      fullPath: '/customer/$token'
      preLoaderRoute: typeof CustomerTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CustomerTokenRoute: CustomerTokenRoute,
  VendorTokenRoute: VendorTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
